import { Auth } from '../utilities/auth';

interface RequestOptions extends RequestInit {
  headers?: Record<string, string>;
}

/**
 * Performs a fetch request with standard headers and error handling.
 * @param url The URL to fetch.
 * @param options Fetch options (method, body, etc.).
 * @param expectJson Whether to expect a JSON response.
 * @returns The fetched data or null on error.
 */
export async function sendRequest(url: string, options: RequestOptions = {}, expectJson: boolean = true) {
  const currentAccessToken = Auth.accessToken;
  if (!currentAccessToken && !window.Cypress) {
    console.error('API Request Error: Access token is not set.');
    return null;
  }

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${currentAccessToken}`,
    ...options.headers,
  };

  try {
    const response = await fetch(url, { ...options, headers });

    if (!response.ok) {
      let errorBody: unknown = null;
      try {
        errorBody = await response.json();
      } catch {
        // Ignore if body isn't JSON
      }

      console.error(`API Error: ${response.status} ${response.statusText}`, {
        url,
        options,
        response,
        errorBody,
      });

      return null;
    }

    if (expectJson) {
      if (response.status === 204 || response.headers.get('content-length') === '0') {
        return {};
      }
      return await response.json();
    }
    return await response.text();
  } catch (error) {
    console.error('Network or Fetch Error:', error);
    return null;
  }
}
